import { useEffect, useRef, useState } from 'react';
import Header from '../components/Header';
import { api, WS_URL } from '../api';
import { useAuth } from '../AuthContext';

export default function AdminPage() {
  const { user: me } = useAuth();
  const [tab, setTab] = useState('users');

  return (
    <div className="app">
      <Header />
      <div className="admin-main">
        <div className="admin-tabs">
          <button
            className={tab === 'users' ? 'tab active' : 'tab'}
            onClick={() => setTab('users')}
          >Kullanicilar</button>
          <button
            className={tab === 'vehicles' ? 'tab active' : 'tab'}
            onClick={() => setTab('vehicles')}
          >Araclar</button>
          <button
            className={tab === 'geofences' ? 'tab active' : 'tab'}
            onClick={() => setTab('geofences')}
          >Geofence</button>
          <button
            className={tab === 'console' ? 'tab active' : 'tab'}
            onClick={() => setTab('console')}
          >Konsol</button>
        </div>
        <div className="admin-content">
          {tab === 'users' && <UsersPanel me={me} />}
          {tab === 'vehicles' && <VehiclesPanel />}
          {tab === 'geofences' && <GeofencesPanel />}
          {tab === 'console' && <ConsolePanel />}
        </div>
      </div>
    </div>
  );
}

// ---------------- USERS ----------------
function UsersPanel({ me }) {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const [form, setForm] = useState({ username: '', password: '', role: 'user' });

  const load = () => api.listUsers().then(setUsers).catch(e => setError(e.message));
  useEffect(() => { load(); }, []);

  const onAdd = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await api.createUser(form.username, form.password, form.role);
      setForm({ username: '', password: '', role: 'user' });
      setShowAdd(false);
      load();
    } catch (err) { setError(err.message); }
  };

  const onChangeRole = async (id, role) => {
    setError(null);
    try { await api.updateRole(id, role); load(); }
    catch (err) { setError(err.message); }
  };

  const onDelete = async (id, username) => {
    if (!window.confirm(`"${username}" silinsin mi?`)) return;
    setError(null);
    try { await api.deleteUser(id); load(); }
    catch (err) { setError(err.message); }
  };

  return (
    <div className="admin-panel">
      <div className="admin-panel-head">
        <h2>Kullanicilar</h2>
        <button className="btn-primary" onClick={() => setShowAdd(s => !s)}>
          {showAdd ? 'Iptal' : '+ Yeni Kullanici'}
        </button>
      </div>

      {error && <div className="admin-error">{error}</div>}

      {showAdd && (
        <form className="admin-form" onSubmit={onAdd}>
          <input
            type="text" placeholder="Kullanici adi" required minLength={3}
            value={form.username} onChange={e => setForm({...form, username: e.target.value})}
          />
          <input
            type="password" placeholder="Sifre (≥6)" required minLength={6}
            value={form.password} onChange={e => setForm({...form, password: e.target.value})}
          />
          <select value={form.role} onChange={e => setForm({...form, role: e.target.value})}>
            <option value="user">Kullanici</option>
            <option value="admin">Admin</option>
          </select>
          <button type="submit" className="btn-primary">Ekle</button>
        </form>
      )}

      <table className="admin-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Kullanici Adi</th>
            <th>Rol</th>
            <th>Olusturuldu</th>
            <th>Islem</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u.id}>
              <td>{u.id}</td>
              <td>
                {u.username}
                {u.id === me?.id && <span className="self-tag"> (sen)</span>}
              </td>
              <td>
                <select
                  value={u.role}
                  disabled={u.id === me?.id}
                  onChange={e => onChangeRole(u.id, e.target.value)}
                >
                  <option value="user">user</option>
                  <option value="admin">admin</option>
                </select>
              </td>
              <td>{new Date(u.created_at).toLocaleDateString('tr-TR')}</td>
              <td>
                <button
                  className="btn-danger"
                  disabled={u.id === me?.id}
                  onClick={() => onDelete(u.id, u.username)}
                >
                  Sil
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// ---------------- VEHICLES ----------------
function VehiclesPanel() {
  const [vehicles, setVehicles] = useState([]);
  const [error, setError] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const [form, setForm] = useState({ id: '', name: '', plate: '', speed_limit_kmh: '' });
  const [editing, setEditing] = useState(null);
  const [editForm, setEditForm] = useState({ name: '', plate: '', speed_limit_kmh: '' });

  const load = () => api.listVehicles().then(setVehicles).catch(e => setError(e.message));
  useEffect(() => { load(); }, []);

  const onAdd = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await api.createVehicle(form.id, form.name, form.plate, form.speed_limit_kmh || null);
      setForm({ id: '', name: '', plate: '', speed_limit_kmh: '' });
      setShowAdd(false);
      load();
    } catch (err) { setError(err.message); }
  };

  const startEdit = (v) => {
    setEditing(v.id);
    setEditForm({
      name: v.name,
      plate: v.plate,
      speed_limit_kmh: v.speed_limit_kmh != null ? String(v.speed_limit_kmh) : '',
    });
  };

  const saveEdit = async (id) => {
    setError(null);
    try {
      await api.updateVehicle(id, editForm.name, editForm.plate, editForm.speed_limit_kmh || null);
      setEditing(null);
      load();
    } catch (err) { setError(err.message); }
  };

  const onDelete = async (id, name) => {
    if (!window.confirm(`"${name}" ve TUM konum gecmisi silinsin mi?`)) return;
    setError(null);
    try { await api.deleteVehicle(id); load(); }
    catch (err) { setError(err.message); }
  };

  return (
    <div className="admin-panel">
      <div className="admin-panel-head">
        <h2>Araclar</h2>
        <button className="btn-primary" onClick={() => setShowAdd(s => !s)}>
          {showAdd ? 'Iptal' : '+ Yeni Arac'}
        </button>
      </div>

      {error && <div className="admin-error">{error}</div>}

      {showAdd && (
        <form className="admin-form" onSubmit={onAdd}>
          <input
            type="text" placeholder="ID (orn: vehicle-2)" required
            value={form.id} onChange={e => setForm({...form, id: e.target.value})}
          />
          <input
            type="text" placeholder="Isim" required
            value={form.name} onChange={e => setForm({...form, name: e.target.value})}
          />
          <input
            type="text" placeholder="Plaka" required
            value={form.plate} onChange={e => setForm({...form, plate: e.target.value})}
          />
          <input
            type="number" placeholder="Hiz limiti km/h (ops.)" min="1" max="300"
            value={form.speed_limit_kmh}
            onChange={e => setForm({...form, speed_limit_kmh: e.target.value})}
          />
          <button type="submit" className="btn-primary">Ekle</button>
        </form>
      )}

      <table className="admin-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Isim</th>
            <th>Plaka</th>
            <th>Hiz Limiti</th>
            <th>Son Goruldu</th>
            <th>Islem</th>
          </tr>
        </thead>
        <tbody>
          {vehicles.map(v => (
            <tr key={v.id}>
              <td>{v.id}</td>
              <td>
                {editing === v.id ? (
                  <input
                    type="text"
                    value={editForm.name}
                    onChange={e => setEditForm({...editForm, name: e.target.value})}
                  />
                ) : v.name}
              </td>
              <td>
                {editing === v.id ? (
                  <input
                    type="text"
                    value={editForm.plate}
                    onChange={e => setEditForm({...editForm, plate: e.target.value})}
                  />
                ) : <span className="vehicle-plate-inline">{v.plate}</span>}
              </td>
              <td>
                {editing === v.id ? (
                  <input
                    type="number" min="1" max="300" placeholder="Limit yok"
                    style={{ width: 90 }}
                    value={editForm.speed_limit_kmh}
                    onChange={e => setEditForm({...editForm, speed_limit_kmh: e.target.value})}
                  />
                ) : (v.speed_limit_kmh != null ? `${v.speed_limit_kmh} km/h` : '—')}
              </td>
              <td>{v.last_seen ? new Date(v.last_seen).toLocaleString('tr-TR') : '—'}</td>
              <td className="admin-actions">
                {editing === v.id ? (
                  <>
                    <button className="btn-primary" onClick={() => saveEdit(v.id)}>Kaydet</button>
                    <button className="btn-secondary" onClick={() => setEditing(null)}>Iptal</button>
                  </>
                ) : (
                  <>
                    <button className="btn-secondary" onClick={() => startEdit(v)}>Duzenle</button>
                    <button className="btn-danger" onClick={() => onDelete(v.id, v.name)}>Sil</button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// ---------------- GEOFENCES ----------------
function GeofencesPanel() {
  const [fences, setFences] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [error, setError] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const [form, setForm] = useState({
    name: '', vehicle_id: '', center_lat: '', center_lon: '', radius_m: 500, active: true,
  });
  const [editing, setEditing] = useState(null);

  const load = () => {
    api.listGeofences().then(setFences).catch(e => setError(e.message));
    api.listVehicles().then(setVehicles).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const resetForm = () => setForm({
    name: '', vehicle_id: '', center_lat: '', center_lon: '', radius_m: 500, active: true,
  });

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!form.center_lat || !form.center_lon) {
      setError('Merkez koordinati gerekli (haritadan tikla veya el ile gir)');
      return;
    }
    try {
      const data = {
        name: form.name,
        vehicle_id: form.vehicle_id || null,
        center_lat: Number(form.center_lat),
        center_lon: Number(form.center_lon),
        radius_m: Number(form.radius_m),
        active: !!form.active,
      };
      if (editing) {
        await api.updateGeofence(editing, data);
      } else {
        await api.createGeofence(data);
      }
      resetForm();
      setEditing(null);
      setShowAdd(false);
      load();
    } catch (err) { setError(err.message); }
  };

  const startEdit = (f) => {
    setEditing(f.id);
    setShowAdd(true);
    setForm({
      name: f.name,
      vehicle_id: f.vehicle_id || '',
      center_lat: String(f.center_lat),
      center_lon: String(f.center_lon),
      radius_m: f.radius_m,
      active: !!f.active,
    });
  };

  const onDelete = async (id, name) => {
    if (!window.confirm(`"${name}" geofence'i silinsin mi?`)) return;
    setError(null);
    try { await api.deleteGeofence(id); load(); }
    catch (err) { setError(err.message); }
  };

  const cancelEdit = () => {
    setEditing(null);
    setShowAdd(false);
    resetForm();
  };

  return (
    <div className="admin-panel">
      <div className="admin-panel-head">
        <h2>Geofence (Dijital Cit)</h2>
        <button className="btn-primary" onClick={() => {
          if (showAdd) cancelEdit();
          else { setShowAdd(true); setEditing(null); resetForm(); }
        }}>
          {showAdd ? 'Iptal' : '+ Yeni Geofence'}
        </button>
      </div>

      {error && <div className="admin-error">{error}</div>}

      {showAdd && (
        <form className="admin-form" onSubmit={onSubmit}>
          <input
            type="text" placeholder="Isim (orn: Okul)" required
            value={form.name} onChange={e => setForm({...form, name: e.target.value})}
          />
          <select value={form.vehicle_id} onChange={e => setForm({...form, vehicle_id: e.target.value})}>
            <option value="">Tum araclar</option>
            {vehicles.map(v => (
              <option key={v.id} value={v.id}>{v.name} ({v.plate})</option>
            ))}
          </select>
          <input
            type="number" step="0.000001" placeholder="Merkez Lat" required
            value={form.center_lat} onChange={e => setForm({...form, center_lat: e.target.value})}
          />
          <input
            type="number" step="0.000001" placeholder="Merkez Lon" required
            value={form.center_lon} onChange={e => setForm({...form, center_lon: e.target.value})}
          />
          <input
            type="number" min="10" max="100000" placeholder="Yaricap (m)" required
            value={form.radius_m} onChange={e => setForm({...form, radius_m: e.target.value})}
          />
          <label className="toggle" style={{ alignSelf: 'center' }}>
            <input
              type="checkbox" checked={form.active}
              onChange={e => setForm({...form, active: e.target.checked})}
            />
            <span>Aktif</span>
          </label>
          <button type="submit" className="btn-primary">{editing ? 'Guncelle' : 'Ekle'}</button>
        </form>
      )}

      <p style={{ fontSize: 13, opacity: 0.7, margin: '8px 0' }}>
        İpucu: Tracker sayfasında haritaya sağ tıklayıp koordinat kopyalayabilirsin (Lat / Lon).
      </p>

      <table className="admin-table">
        <thead>
          <tr>
            <th>Isim</th>
            <th>Arac</th>
            <th>Merkez</th>
            <th>Yaricap</th>
            <th>Durum</th>
            <th>Islem</th>
          </tr>
        </thead>
        <tbody>
          {fences.length === 0 && (
            <tr><td colSpan={6} style={{ textAlign: 'center', opacity: 0.6 }}>Henuz geofence yok.</td></tr>
          )}
          {fences.map(f => {
            const v = vehicles.find(x => x.id === f.vehicle_id);
            return (
              <tr key={f.id}>
                <td>{f.name}</td>
                <td>{f.vehicle_id ? (v ? `${v.name} (${v.plate})` : f.vehicle_id) : <em>tum araclar</em>}</td>
                <td><code>{f.center_lat.toFixed(5)}, {f.center_lon.toFixed(5)}</code></td>
                <td>{f.radius_m >= 1000 ? `${(f.radius_m/1000).toFixed(1)} km` : `${Math.round(f.radius_m)} m`}</td>
                <td>{f.active ? '✅ aktif' : '⏸ pasif'}</td>
                <td className="admin-actions">
                  <button className="btn-secondary" onClick={() => startEdit(f)}>Duzenle</button>
                  <button className="btn-danger" onClick={() => onDelete(f.id, f.name)}>Sil</button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

// ---------------- CONSOLE ----------------
function ConsolePanel() {
  const [vehicles, setVehicles] = useState([]);
  const [vehicleId, setVehicleId] = useState('');
  const [logs, setLogs] = useState([]);
  const [commands, setCommands] = useState([]);
  const [error, setError] = useState(null);
  const [autoScroll, setAutoScroll] = useState(true);
  const [busy, setBusy] = useState(false);
  const logEndRef = useRef(null);

  // Vehicles list
  useEffect(() => {
    api.listVehicles()
      .then(vs => {
        setVehicles(vs);
        if (vs.length > 0 && !vehicleId) setVehicleId(vs[0].id);
      })
      .catch(e => setError(e.message));
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  // Logs + commands when vehicle changes
  useEffect(() => {
    if (!vehicleId) return;
    api.deviceLogs(vehicleId).then(setLogs).catch(e => setError(e.message));
    api.deviceCommands(vehicleId).then(setCommands).catch(e => setError(e.message));
  }, [vehicleId]);

  // WebSocket for live updates
  useEffect(() => {
    if (!vehicleId) return;
    const ws = new WebSocket(WS_URL);
    ws.onmessage = (event) => {
      const msg = JSON.parse(event.data);
      if (msg.type === 'device_log' && msg.data.vehicle_id === vehicleId) {
        setLogs(prev => [...prev.slice(-499), msg.data]);
      }
      if (msg.type === 'device_command' && msg.data.vehicle_id === vehicleId) {
        setCommands(prev => {
          const others = prev.filter(c => c.id !== msg.data.id);
          return [msg.data, ...others].slice(0, 30);
        });
      }
    };
    return () => ws.close();
  }, [vehicleId]);

  // Auto-scroll to bottom on new logs
  useEffect(() => {
    if (autoScroll && logEndRef.current) {
      logEndRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [logs, autoScroll]);

  const sendCommand = async (cmd, payload) => {
    setError(null);
    setBusy(true);
    try {
      await api.deviceCommand(vehicleId, cmd, payload);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  const onReboot = async () => {
    if (!window.confirm('ESP yeniden baslatilsin mi?')) return;
    await sendCommand('reboot', null);
  };

  const onClearLogs = async () => {
    if (!window.confirm('Loglar silinsin mi?')) return;
    await api.clearDeviceLogs(vehicleId);
    setLogs([]);
  };

  return (
    <div className="admin-panel console-panel">
      <div className="admin-panel-head">
        <h2>Cihaz Konsolu</h2>
        <select
          className="vehicle-select"
          value={vehicleId}
          onChange={e => setVehicleId(e.target.value)}
        >
          {vehicles.map(v => (
            <option key={v.id} value={v.id}>{v.name} ({v.id})</option>
          ))}
        </select>
      </div>

      {error && <div className="admin-error">{error}</div>}

      <div className="console-layout">
        {/* SOL: log akisi */}
        <div className="console-logs-wrap">
          <div className="console-toolbar">
            <label className="toggle">
              <input
                type="checkbox"
                checked={autoScroll}
                onChange={e => setAutoScroll(e.target.checked)}
              />
              <span>Otomatik kaydir</span>
            </label>
            <span className="log-count">{logs.length} satir</span>
            <button className="btn-secondary" onClick={onClearLogs}>Temizle</button>
          </div>
          <div className="console-logs">
            {logs.length === 0 ? (
              <div className="log-empty">Henuz log yok. ESP baglandiginda buraya akmaya baslayacak.</div>
            ) : logs.map((l, i) => (
              <div key={l.id || i} className={`log-line log-${(l.level || 'info').toLowerCase()}`}>
                <span className="log-time">{formatLogTime(l.ts)}</span>
                <span className="log-level">{l.level}</span>
                <span className="log-msg">{l.message}</span>
              </div>
            ))}
            <div ref={logEndRef} />
          </div>
        </div>

        {/* SAG: komutlar */}
        <div className="console-commands">
          <div className="cmd-block">
            <h4>Sistem</h4>
            <p className="cmd-desc">
              WiFi ESP'de hardcoded: once <strong>TunikIoT</strong>, baglanamazsa <strong>Tunahan's iPhone</strong>.
            </p>
            <button className="btn-secondary" onClick={onReboot} disabled={busy || !vehicleId}>
              ↻ Yeniden Baslat
            </button>
          </div>

          <div className="cmd-block">
            <h4>Son Komutlar</h4>
            {commands.length === 0 ? (
              <p className="cmd-desc">Henuz komut yok.</p>
            ) : (
              <div className="cmd-history">
                {commands.map(c => (
                  <div key={c.id} className={`cmd-row cmd-${c.status}`}>
                    <span className="cmd-name">{c.cmd}</span>
                    <span className={`cmd-status status-${c.status}`}>{c.status}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function formatLogTime(ts) {
  if (!ts) return '';
  const d = new Date(ts);
  return d.toLocaleTimeString('tr-TR', { hour12: false });
}
